const ApiDetails = () => import("./views/ApiDetails.vue");
const ApiKeyAddEdit = () => import("./views/ApiKeyAddEdit.vue");
const AdminApis = () => import("./views/AdminApis.vue");

export const apiRoutes = [
  {
    path: "/admin/apis",
    name: "AdminApis",
    component: AdminApis,
  },
  {
    path: "/admin/apis/edit/:id?",
    name: "ApiKeyAddEdit",
    component: ApiKeyAddEdit,
    props: true,
  },
  {
    path: "/admin/apis/details/:id?",
    name: "ApiDetails",
    component: ApiDetails,
    props: true,
  },
];
